// extracted by mini-css-extract-plugin
export default {"root":"_3KiNE","cover":"_3oIa3","middle":"_1wrUG","mature-block":"W3Lk4","matureBlock":"W3Lk4","underlay":"_2CFMn"};